// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131157/js/" + chunkId + "." + {"44":"299970e0","225":"b63a8644","481":"ea19806e","486":"19239ee3","770":"1a16dd38"}[chunkId] + ".0.20862702907891606.chunk.js";
};